import React from 'react';
import { cn } from '../lib/utils';
import FeedbackButtons from './FeedbackButtons';
import ConfirmationButtons from './ConfirmationButtons';
import { useChatStore } from '../stores/chat-store';

interface ChatMessageProps {
  message: {
    id: string;
    role: 'user' | 'assistant';
    content: string;
    pendingAction?: boolean;
    proactive?: boolean;
    created_at?: string;
  };
  surface?: 'app' | 'marketing';
}

const ChatMessage: React.FC<ChatMessageProps> = ({ message, surface = 'app' }) => {
  const { pendingAction } = useChatStore();
  const isUser = message.role === 'user';

  return (
    <div
      data-role={message.role}
      className={cn(
        'flex w-full mb-3',
        isUser ? 'justify-end' : 'justify-start'
      )}
    >
      <div
        className={cn(
          'max-w-[80%] rounded-lg px-3 py-2 text-sm',
          isUser
            ? 'bg-bronze-700 text-white rounded-br-none'
            : 'bg-background-alt text-text rounded-bl-none'
        )}
      >
        <p className="whitespace-pre-wrap break-words">{message.content}</p>
        {!isUser && <FeedbackButtons messageId={message.id} />}
        {!isUser &&
          message.pendingAction &&
          pendingAction !== null &&
          surface !== 'marketing' && <ConfirmationButtons />}
      </div>
    </div>
  );
};

export default ChatMessage;
